<template>
  <div>
    <div class="container">
      <div class="row justify-content-between">
        <div class="px-2">
          <el-form
            ref="queryForm"
            :model="queryForm"
            label-width="100px"
            :inline="true"
            @keyup.enter.native="handleQueryClick(queryForm)"  @submit.native.prevent
          >
            <el-form-item label="部門" label-width="50px">
              <el-select
                v-model="queryForm.dept"
                size="small"
                class="selectqry"
              >
                <el-option
                  v-for="item in myDepts"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="關鍵字" label-width="60px">
              <el-input
                v-model="queryForm.qstr"
                placeholder="名稱"
                size="small"
                style="width:100px"
              ></el-input>
            </el-form-item>

            <el-form-item label="顏色" label-width="65px">
              <div
                style="width:335px;marginBottom:-20px"
                >
                <el-checkbox-group v-model="queryForm.colors">
                  <el-checkbox
                    v-for="itemColor in extTagColorList"
                    :key="itemColor.name"
                    :label="itemColor.name"
                    style="width:35px"
                  >
                    <span :style="{ color: itemColor.textColor, marginLeft: '-5px'}" >
                      {{ itemColor.txtLabel }}
                    </span>
                  </el-checkbox
                  >
                </el-checkbox-group>
              </div>
            </el-form-item>

            <el-form-item>
              <el-button
                type="primary"
                @click="handleQueryClick(queryForm)"
                style="marginLeft:-10px"
                size="small"
                >查詢</el-button
              >
            </el-form-item>
          </el-form>
        </div>
        <div class="funcpanel">
          <el-button
            type="primary"
            icon="el-icon-plus"
            @click="addNewGroup"
            size="small"
            >新增群組</el-button
          >
        </div>
      </div>
    </div>

    <CCard>
      <CCardHeader>
        <CIcon name="cil-library-building" /> 部門：{{
          getDeptName(activeQueryForm.dept)
        }}
      </CCardHeader>
      <CCardBody>
        <CRow>
          <el-table
          :border="true"
            :data="groups"
            @sort-change="sortChange"
            :default-sort="{ prop: 'startDate', order: 'descending' }"
            stripe
            style="width: 100%"
          >
            <el-table-column type="index" :index="indexFormatter" fixed>
            </el-table-column>

            <!--<el-table-column label="所屬部門" prop="deptName" width="150">-->
            <!--<template #default>-->
            <!--{{ getDeptName(activeQueryForm.dept) }}-->
            <!--</template>-->
            <!--</el-table-column>-->

            <el-table-column
              label="群組名稱"
              prop="name"
              sortable="custom"
              width="200"
            >
              <template #default="scope">
                <el-tag :style="getTagStyle(scope.row.color)">{{ scope.row.name }}</el-tag>
              </template>
            </el-table-column>

            <el-table-column label="操作">
              <template #default="scope">
                <el-button size="mini" @click="editGroupMbr(scope.row)"
                  >成員管理
                </el-button>
                <el-button size="mini" @click="grpSubscribe(scope.row)"
                  >訂閱管理
                </el-button>

                <!--<el-button disabled size="mini" @click="editGroup(scope.row.id)" >審核 </el-button>-->

                <el-button size="mini" @click="editGroup(scope.row.id)"
                  >編輯
                </el-button>
                <el-button
                  type="danger"
                  size="mini"
                  @click="deleteGroup(scope.row.id)"
                  >刪除
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </CRow>
        <CRow>
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="currentPage"
            :page-sizes="[50, 100, 200]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
          >
          </el-pagination>
        </CRow>
        <AddEdtGroupDlg
          v-model="isAddEdtGroupDlgVisible"
          :deptId="activeQueryForm.dept"
          :deptName="getDeptName(activeQueryForm.dept)"
          :selectedItemId="selectedItemId"
          :key="`addEdtGrp_${dlgKey}`"
        ></AddEdtGroupDlg>

        <EditGroupMbrDlg
          v-model="isEdtGrpDlgVisible"
          :deptId="activeQueryForm.dept"
          :deptName="getDeptName(activeQueryForm.dept)"
          :groupId="selectedItemId"
          :groupName="selectedGroupName"
          :key="`grpMbr_${editGrpMbrDlgKey}`"
        ></EditGroupMbrDlg>

        <GrpSubsMgmtDlg
          v-model="isGrpSubsDlgVisible"
          :groupId="selectedItemId"
          :groupName="selectedGroupName"
          :key="`grpSubs_${grpSubsDlgKey}`"
        ></GrpSubsMgmtDlg>
      </CCardBody>
    </CCard>
  </div>
</template>

<script>
import API from "@/api";
import { mapGetters } from "vuex";
import AddEdtGroupDlg from "@/components/dept/AddEdtGroupDlg";
import EditGroupMbrDlg from "@/components/dept/EditGroupMbrDlg";
//import GroupSubsDlg from "@/components/dept/GroupSubsDlg";
import GrpSubsMgmtDlg from "@/components/dept/GrpSubsMgmtDlg";
import tagColorsMixin from "@/components/mixin/tagColors.js";
export default {
  name: "deptGroupList",
  mixins: [tagColorsMixin],
  components: {
    AddEdtGroupDlg,
    EditGroupMbrDlg,
    GrpSubsMgmtDlg,
  },
  created() {
    this.$store.commit("group/CLEAR");
    API.my.depts().then(res => {
      //console.log('myDepts:', JSON.stringify(res.data))
      this.myDepts = res.data;
      this.queryForm.dept = res.data[0].id;
      this.activeQueryForm.dept = res.data[0].id;

      this.$store.dispatch("group/list", {
        max: this.pageSize,
        offset: this.offset,
        sort: this.sort,
        order: this.order,
        dept: this.queryForm.dept,
      });
    });
  },
  data() {
    return {
      myDepts: [],
      selectedItemId: null,
      selectedGroupName: "",
      dlgKey: 0,
      editGrpMbrDlgKey: 0,
      grpSubsDlgKey: 0,
      isAddEdtGroupDlgVisible: false,
      isEdtGrpDlgVisible: false,
      isGrpSubsDlgVisible: false,
      pageSize: 50,
      currentPage: 1,
      queryForm: {
        dept: 0,
        qstr: "",
        colors: [],
      },
      activeQueryForm: {
        dept: 0,
        qstr: "",
        colors: [],
      },
    };
  },
  methods: {
    getDeptName(deptId) {
      const dept = this.myDepts.find(dept => dept.id === deptId);
      return dept?.name ?? "";
    },
    handleQueryClick(queryForm) {
      this.currentPage = 1; //reset pagination to the first page
      this.activeQueryForm = { ...queryForm };
      this.query(this.pageSize, 0, this.sort, this.order, this.activeQueryForm);
    },
    addNewGroup() {
      this.selectedItemId = null;
      this.dlgKey = this.dlgKey ? 0 : 1;
      this.isAddEdtGroupDlgVisible = true;
    },
    editGroup(itemId) {
      /*console.log(`editGroup: itemId = ${itemId}`);*/
      this.selectedItemId = itemId;
      this.dlgKey = this.dlgKey ? 0 : 1;
      this.isAddEdtGroupDlgVisible = true;
    },
    grpSubscribe(group) {
      this.selectedItemId = group.id;
      this.selectedGroupName = group.name;
      this.grpSubsDlgKey = this.grpSubsDlgKey ? 0 : 1;
      this.isGrpSubsDlgVisible = true;
    },
    editGroupMbr(group) {
      this.selectedItemId = group.id;
      this.selectedGroupName = group.name;
      this.editGrpMbrDlgKey = this.editGrpMbrDlgKey ? 0 : 1;
      this.isEdtGrpDlgVisible = true;
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.query(val, this.offset, this.sort, this.order, this.activeQueryForm);
    },
    handleCurrentChange(page) {
      this.query(
        this.pageSize,
        this.pageSize * (page - 1),
        this.sort,
        this.order,
        this.activeQueryForm
      );
    },
    query(max, offset, sort, order, params = {}) {
      this.$store.dispatch("group/list", {
        max: max,
        offset: offset,
        sort,
        order,
        ...params,
      });
    },
    indexFormatter(index) {
      return `#${parseInt(this.offset) + index + 1}`;
    },
    deleteGroup(itemId) {
      this.$confirm("此操作將永久刪除該群組, 是否繼續?", "提示", {
        confirmButtonText: "確定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$store.dispatch("group/remove", itemId).then(() => {
            this.query(
              this.pageSize,
              this.offset,
              this.sort,
              this.order,
              this.activeQueryForm
            );
            this.$message({
              type: "success",
              message: "删除成功!",
            });
          });
        })
        .catch(() => {
          /*this.$message({*/
          /*type: 'info',*/
          /*message: '已取消删除'*/
          /*});          */
        });
    },
    sortChange(args) {
      if (args.order === null) {
        this.$store.commit("group/SET_SORT", "id");
        this.$store.commit("group/SET_ORDER", "ascending");
      } else {
        this.$store.commit("group/SET_SORT", args.prop);
        this.$store.commit("group/SET_ORDER", args.order);
      }
      this.query(
        this.pageSize,
        this.offset,
        this.sort,
        this.order,
        this.activeQueryForm
      );
    },
  },
  computed: {
    ...mapGetters({
      myownOrg: "auth/orgName",
      groups: "group/groups",
      total: "group/total",
      offset: "group/offset",
      getGroupById: "group/getGroupById",
      sort: "group/sort",
      order: "group/order",
    }),
  },
};
</script>

<style>
.colorcheck {
  width: 20px;
}
</style>
